/**
 * @owner @Appboy/frontend-ix
 */

import Highcharts from "./highcharts";

export default Highcharts;

export * from "./base-chart-config";
